<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryItems, activeIndex } = useUiMediaGallery(props.name)
</script>

<template>
  <div class="media-gallery-x-of-y">
    <span class="media-gallery-x-of-y__x">{{ activeIndex + 1 }}</span>
    <slot name="divider">
      /
    </slot>
    <span class="media-gallery-x-of-y__y">{{ galleryItems.length }}</span>
  </div>
</template>

<style>
@import url("~layers/components/Ui/MediaGallery/XofY.css");
</style>
